import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { LocalizationModule } from '@nimbus-library/features/localization/localization.module';
import { SharedUIModule } from '@nimbus-library/features/shared/shared.ui.module';
import { ModalModule } from '@nimbus-library/features/modal/modal.module';
import { GeoLocationRoutingModule } from './geo-location-routing.module';
import { LocationListComponent } from './components/location-list/location-list.component';
import { LocationSelectorContainerComponent } from './pages/location-selector-container/location-selector-container.component';
import { LocationSelectorModalComponent } from './modals/location-selector-modal/location-selector-modal.component';

@NgModule({
  declarations: [LocationListComponent, LocationSelectorContainerComponent, LocationSelectorModalComponent],
  imports: [CommonModule, GeoLocationRoutingModule, LocalizationModule, ModalModule, MatDialogModule, SharedUIModule, ReactiveFormsModule],
})
export class GeoLocationModule {}
